<template>
    <div>
        <canvas ref="chartCanvas"></canvas>
    </div>
</template>

<script>
    import Chart from 'chart.js';

    export default {
        name: 'VisualizeChart',
        props: {
            chartData: Object,
            chartOptions: Object
        },
        data(){
            return {
                chartObj: undefined,
            }
        },
        mounted() {
            this.updateChart();
        },
        methods: {
            updateChart() {
                if (this.chartObj) {
                    this.chartObj.destroy();
                }
                this.renderChart(); // Or any method to re-create the chart
            },
            renderChart() {
                if (this.$refs.chartCanvas) {
                    this.chartObj = new Chart(this.$refs.chartCanvas, {
                        type: 'line', // Change to your desired chart type
                        data: this.chartData,
                        options: this.chartOptions
                    });
                }
            },
        },
        watch: {
            chartData: {
                handler() {
                    this.updateChart();
                },
                deep: true
            }
        }
    };
</script>